import React from 'react';
import cx from 'classnames';

interface Props {
  hasToCall: boolean;
  revealNumber: boolean;
  type: 'big' | 'small';
  dataValue?: string;
  dataValueClassName?: string;
}
export const SeeNumber = ({
  hasToCall,
  revealNumber,
  type,
  dataValue,
  dataValueClassName,
}: Props) => {
  const typeParagraph = hasToCall ? 'Ver telefone' : 'Ver Whatsapp';
  const commonStyle = 'fw6 white underline pl4 ma0';
  const smallStyle = cx(commonStyle, 'f14 f16-l');
  const bigStyle = cx(
    'nowrap f24 lh-solid',
    {
      'mw-100': !revealNumber,
      mw1: revealNumber,
    },
    commonStyle,
  );
  const seeNumberClass = cx(dataValueClassName, {
    [bigStyle]: type === 'big',
    [smallStyle]: type === 'small',
  });
  return (
    <span className={seeNumberClass} title={typeParagraph} data-value={dataValue}>
      {typeParagraph}
    </span>
  );
};
